import { render, staticRenderFns } from "./tabOptIn.vue?vue&type=template&id=f70774a6"
import script from "./tabOptIn.vue?vue&type=script&lang=js"
export * from "./tabOptIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports